import { Button, Dialog, DialogTitle, Divider, FormControl, Grid, InputLabel, Paper, Select, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Typography, styled, tableCellClasses } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { Col, Row } from 'react-bootstrap';
import Home from '../home/Home';
import PaymentExpensesServices from '../../Services/payment_expenses/PaymentExpensesServices';
import Snackbar from '../Snacbar'
import { getDate, getPointId, getUserId } from '../Utils/Common';
import FileSaver from 'file-saver';


const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
        color: theme.palette.common.black,
        backgroundColor: 'rgb(61, 195, 177)',
        padding: theme.spacing(0.5),
        fontFamily: 'Times New Roman',
        fontWeight: 'bold',
    },
    [`&.${tableCellClasses.body}`]: {
        fontSize: 14,
        fontFamily: 'Times New Roman',

    },
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: 'white',
    },
}));


const Item = styled(Paper)(({ theme }) => ({
    ...theme.typography.body2,
    padding: theme.spacing(1),
    // textAlign: 'center',
    color: theme.palette.text.secondary,
    backgroundColor: 'white',
    height: '100%',
    border: '1px solid black'
}));

function MiscellaneousPayment() {
    const [imgUpload, setimgUpload] = useState(false);
    const [values, setValues] = useState({
        job_no: '',
        // dutyamt_as_perBoe: '',
        dutyPaidAmt: '',
        dutyPaidDate: '',
        dutyPaidBy: '',
        dutyPaidTo: '',
        OldPaidTo: '',
        remarks: ''

    });
    const [savePrc, setSaveProc] = useState(false);
    const [updatePrc, setUpdateProc] = useState(false);
    const [deletePrc, setDeleteProc] = useState(false);

    const [saveDis, setSaveDis] = useState(false);
    const [updateDis, setUpdateDis] = useState(true);
    const [DeleteDis, setDeleteDis] = useState(true);
    const [checklistCopy, SetchecklistCopy] = useState('');
    const [jobvalue, setJobValue] = useState('');

    const [importer, setImporter] = useState('');

    const [importerData, setImporterData] = useState([]);
    const [billData, setBillData] = useState([]);
    const [DutyPaymentResult, setDutyPaymentResult] = useState([]);
    const [JobTrackingDetails, setJobTrackingDetails] = useState([]);

    const [nonDutyData, setNonDutyData] = useState([]);
    // const [DutyData, setDutyData] = useState([]);
    const [message, setMessage] = useState('');
    const [open, setOpen] = useState(false);
    const [severit, setseverit] = useState('');
    const [alertopen, setalertopen] = useState(false);

    const importerHandelChange = (e) => {
        setImporter(e.target.value);
        var iecno = '';
        if (e.target.value === '') {
            iecno = '-1';
        } else {
            iecno = e.target.value;
        }
        let details = { importer_iec_no: iecno, consignmentNumber: '-1', status: 12 }

        PaymentExpensesServices.getJobNoBasedImpCMNonUploadCL(details).then((res) => {
            setNonDutyData(res.data);
        });
        // let details1 = { importer_iec_no: iecno, consignmentNumber: '-1', status: 9 }

        // PaymentExpensesServices.getJobNoBasedImpCMUploadCL(details1).then((res) => {
        //     setDutyData(res.data);
        // });
    }

    const jobhandelChange = (e) => {
        setJobValue(e.target.value);
        var job = '';
        if (e.target.value === '') {
            job = '-1';
        } else {
            job = e.target.value;
        }
        let details = { importer_iec_no: '-1', consignmentNumber: job, status: 12 }

        PaymentExpensesServices.getJobNoBasedImpCMNonUploadCL(details).then((res) => {
            setNonDutyData(res.data);
        });
        // let details1 = { importer_iec_no: '-1', consignmentNumber: job, status: 10 }

        // PaymentExpensesServices.getJobNoBasedImpCMUploadCL(details1).then((res) => {
        //     setDutyData(res.data);
        // });
    }

    // const dutyamt_as_perBoeHandelChange = (e) => {
    //     setValues({ ...values, dutyamt_as_perBoe: e.target.value });
    // }

    const dutyPaidAmtHandelChange = (e) => {
        setValues({ ...values, dutyPaidAmt: e.target.value });
    }

    const dutyPaidDatehandelChange = (e) => {
        setValues({ ...values, dutyPaidDate: e.target.value });
    }

    const dutyPaidByHandelChange = (e) => {
        setValues({ ...values, dutyPaidBy: e.target.value });
    }

    const dutyPaidToHandelChange = (e) => {
        setValues({ ...values, dutyPaidTo: e.target.value });
    }

    const remarksHandelChange = (e) => {
        setValues({ ...values, remarks: e.target.value });
    }

    const getImporterData = () => {
        PaymentExpensesServices.getImporterDetails().then((res) => {
            setImporterData(res.data);
        })
        PaymentExpensesServices.getbillName("MISCELLANEOUS CHARGE").then((res) => {
            setBillData(res.data);
        })
    }
    const getJobNoBasedImpCMNonUploadCL = () => {

        let details = { importer_iec_no: '-1', consignmentNumber: '-1', status: 12 }

        PaymentExpensesServices.getJobNoBasedImpCMNonUploadCL(details).then((res) => {
            setNonDutyData(res.data);
        });
    }
    // const getJobNoBasedImpCMUploadCL = () => {

    //     let details = { importer_iec_no: '-1', consignmentNumber: '-1', status: 10 }

    //     PaymentExpensesServices.getJobNoBasedImpCMUploadCL(details).then((res) => {
    //         setDutyData(res.data);
    //     });
    // }

    useEffect(() => {
        getImporterData();
        getJobNoBasedImpCMNonUploadCL();
        // getJobNoBasedImpCMUploadCL();
    }, []);

    const edit_nonDutyAssign = (item) => {
        setSaveDis(false);
        setUpdateDis(true);
        setDeleteDis(true);
        setSaveProc(false);
        setUpdateProc(false);
        setDeleteProc(false);
        PaymentExpensesServices.getAllPayment(item.consignmentNumber,"MISCELLANEOUS CHARGE").then((res) => {
            setDutyPaymentResult(res.data);
            // if (!itemVerialbel[0]) {
            //     SetchecklistCopy('')
                setValues({...values, job_no: item.consignmentNumber});
            // }
            // else {
            //     SetchecklistCopy(itemVerialbel[0].tspPaidCopy)
            //     setValues({
            //         ...values, job_no: item.consignmentNumber,
            //         dutyPaidAmt: itemVerialbel[0].tspAmt, dutyPaidDate: itemVerialbel[0].tspPaidDate, dutyPaidBy: itemVerialbel[0].tspPaidBy,
            //         remarks: itemVerialbel[0].remarks
            //     });
            // }
        }).catch((error) => {
            console.log("error ", error)
        });
        PaymentExpensesServices.getJobTrackingDetails(item.consignmentNumber).then((res) => {
            setJobTrackingDetails(res.data);
        }).catch((error) => {
            console.log("error ", error)
        });
        reset();
    }
    const edit_DutyAssign = (item) => {
        setSaveDis(true);
        setUpdateDis(false);
        setDeleteDis(false);
        setSaveProc(false);
        setUpdateProc(false);
        setDeleteProc(false);
       
                SetchecklistCopy(item.tspPaidCopy)
                setValues({
                    ...values, job_no: item.consignmentId,OldPaidTo:item.tspPaidTo,dutyPaidTo:item.tspPaidTo,
                    dutyPaidAmt: item.tspAmt, dutyPaidDate: item.tspPaidDate, dutyPaidBy: item.tspPaidBy,
                    remarks: item.remarks
                });
          
    }

    const velidetion = () => {
        // if (!values.dutyamt_as_perBoe || values.dutyamt_as_perBoe === '') {
        //     setMessage('Duty Amount as per Boe is Empty');
        //     setseverit('warning');
        //     setOpen(true);
        // } else {
            if (!values.dutyPaidAmt || values.dutyPaidAmt === '') {
                setMessage('Duty Paid Amount is Empty');
                setseverit('warning');
                setOpen(true);
            } else {
                if (!values.dutyPaidDate || values.dutyPaidDate === '') {
                    setMessage('Duty Paid Date is Empty');
                    setseverit('warning');
                    setOpen(true);
                } else {
                    if (!values.dutyPaidBy || values.dutyPaidBy === '') {
                        setMessage('Duty Paid By is Empty');
                        setseverit('warning');
                        setOpen(true);
                    } else {
                        return true;
                    }
                }
            }
        // }
        return false;
    }

    const Save = () => {
        if (velidetion() === true) {
            if (values.job_no !== '') {
                setSaveDis(true);
                setSaveProc(true);
                var dutyPaidCopy = '';
                if (checklistCopy !== '') {
                    dutyPaidCopy = checklistCopy;
                } else {
                    dutyPaidCopy = null;
                }
                let details = {
                    consignmentId: values.job_no, tspAmt: values.dutyPaidAmt,tspPaidTo:values.dutyPaidTo,
                    tspPaidDate: values.dutyPaidDate, tspPaidBy: values.dutyPaidBy, tspPaidCopy: dutyPaidCopy, createdBy: getUserId(), pointId: getPointId(), remarks: values.remarks
                }
                PaymentExpensesServices.insertTspPayment(details).then((res) => {
                    const data = res.data;
                    PaymentExpensesServices.getAllPayment(values.job_no,"MISCELLANEOUS CHARGE").then((res) => {
                        setDutyPaymentResult(res.data);
                    }).catch((error) => {
                        console.log("error ", error)
                    });
                    setMessage(data.message[0]);
                    setseverit('success');
                    setOpen(true); reset();
                }).catch((error) => {
                    console.log('error ', error); reset();
                })
            }

        }
    }
    const Update = () => {
        if (velidetion() === true) {
            if (values.job_no !== '') {
                setUpdateDis(true);
                setUpdateProc(true);
                var dutyPaidCopy = '';
                if (checklistCopy !== '') {
                    dutyPaidCopy = checklistCopy;
                } else {
                    dutyPaidCopy = null;
                }
                let details = {
                    consignmentId: values.job_no, tspAmt: values.dutyPaidAmt,tspPaidTo:values.dutyPaidTo,oldPaidTo:values.OldPaidTo,
                    tspPaidDate: values.dutyPaidDate, tspPaidBy: values.dutyPaidBy, tspPaidCopy: dutyPaidCopy, createdBy: getUserId(), pointId: getPointId(), remarks: values.remarks
                }
                PaymentExpensesServices.updateAllPayment(details).then((res) => {
                    const data = res.data;
                    PaymentExpensesServices.getAllPayment(values.job_no,"MISCELLANEOUS CHARGE").then((res) => {
                        setDutyPaymentResult(res.data);
                    }).catch((error) => {
                        console.log("error ", error)
                    });
                    setMessage(data.message[0]);
                    setseverit('success');
                    setOpen(true); reset();
                }).catch((error) => {
                    console.log('error ', error); reset();
                })
            }
        }

    }
    const Delete = () => {
        if (velidetion() === true) {
            if (values.job_no !== '') {
                setDeleteDis(true);
                setDeleteProc(true);
                PaymentExpensesServices.deleteAllPayment(values.job_no,values.OldPaidTo).then((res) => {
                    const data = res.data;
                    PaymentExpensesServices.getAllPayment(values.job_no,"MISCELLANEOUS CHARGE").then((res) => {
                        setDutyPaymentResult(res.data);
                    }).catch((error) => {
                        console.log("error ", error)
                    });
                    setMessage(data.message[0]);
                    setseverit('success');
                    setOpen(true); reset();
                }).catch((error) => {
                    console.log('error ', error); reset();
                })
            }
        }

    }

    const reset = () => {
        SetchecklistCopy('');
        setValues({
            ...values,dutyPaidAmt: '', dutyPaidDate: '', dutyPaidBy: '', remarks: '',dutyPaidTo:'',OldPaidTo:''
        });
        setSaveDis(false);
        setUpdateDis(true);
        setDeleteDis(true);
        setSaveProc(false);
        setUpdateProc(false);
        setDeleteProc(false);
        getImporterData();
        getJobNoBasedImpCMNonUploadCL();
        // getJobNoBasedImpCMUploadCL();
    }

    const handleClose = () => {
        setOpen(false)
    }

    const saveDutyCopy = () => {
        if (values.job_no === '' || !values.job_no) {

            setMessage("Please Select Job Tabel............");
            setseverit('warning');
            setOpen(true);
        }
        else {
            const filedata = checklistCopy;
            const formates = filedata.split('/9j/4');

            if (formates[0] === '') {
                FileSaver.saveAs(`data:image/jpg;base64,${filedata}`, 'Duty_' + getDate() + ".jpg");
            } else {
                const Pngformates = filedata.split('iVBORw0KGg');
                if (Pngformates[0] === '') {
                    FileSaver.saveAs(`data:image/jpg;base64,${filedata}`, 'Duty_' + getDate() + ".jpg");
                } else {
                    FileSaver.saveAs(`data:application/pdf;base64,${filedata}`, 'Duty_' + getDate() + ".pdf");
                }
            }
        }

    }

    const uploadrqstcopy = () => {
        console.log('onclick in')
        if (values.job_no === '' || !values.job_no) {

            setMessage("Please Select Job Tabel............");
            setseverit('warning');
            setOpen(true);
            setimgUpload(false);
        }
        else {
            setimgUpload(true);
        }
    }

    const selectimgUpload = (event) => {
        var currentFile;
        const file = event.target.files[0];
        const imageMimeTypepng = /image\/(png)/i;
        const imageMimeTypejpg = /image\/(jpg)/i;
        const imageMimeTypeJpeg = /image\/(jpeg)/i;
        const imageMimeTypePdf = /(pdf)/i;
        const reader = new FileReader();
        reader.onload = () => {

            currentFile = reader.result;
            var recipetCopyFile = '';
            if (file.type.match(imageMimeTypepng)) {
                recipetCopyFile = currentFile.split("data:image/png;base64,");
            } else if (file.type.match(imageMimeTypejpg)) {
                recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
            }
            else if (file.type.match(imageMimeTypeJpeg)) {
                recipetCopyFile = currentFile.split("data:image/jpeg;base64,");
            }
            else if (file.type.match(imageMimeTypePdf)) {
                recipetCopyFile = currentFile.split("data:application/pdf;base64,");
            }

            if (reader.readyState === 2) {
                SetchecklistCopy(recipetCopyFile[1]);
            }
        }
        reader.readAsDataURL(event.target.files[0])
    }

    const alertYDeleteClick=()=>{
        setalertopen(true)
    }
    const alertNoOnClick = () => {
        reset();
        setalertopen(false)
      }
    
      const alertYesOnClick = () => {
        Delete();
        setalertopen(false)
    
      }
    return (
        <div>
            <Dialog open={alertopen}>
                <DialogTitle>
                    <center style={{ fontFamily: 'Times New Roman' }}><h6>ARE YOU SURE,</h6></center>
                    <h6 style={{ fontFamily: 'Times New Roman' }}>YOU WANT TO DELETE ?</h6>
                    <Divider color="#FDA228" sx={{ height: 2 }} />
                </DialogTitle>
                <div className="form-inline p-1">
                    <center><Button variant="danger" className="p-1 mb-2 mr-1" style={{ width: '50px' }} onClick={alertYesOnClick}>Yes</Button>&nbsp;
                        <Button variant="success" className="p-1 mb-2 " style={{ width: '50px' }} onClick={alertNoOnClick}>No</Button></center>
                </div>
            </Dialog>
            <Home />
            <Snackbar open={open} message={message} severity={severit} onClose={handleClose} />
            <div style={{ paddingLeft: '80px', transition: '1s', transitionDelay: 'revert-layer' }}>
                <center>
                    <Typography style={{ fontFamily: 'Times New Roman', color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '4%' }}>MISCELLANEOUS PAYMENT</Typography>
                </center>
                <Grid container>
                    <Grid item xs={2}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '7px', fontFamily: 'Times New Roman' }}>Job No</lable>
                            <TableContainer sx={{ maxHeight: 500 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Job.No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>

                                        {nonDutyData.map((item) => (
                                            <TableRow hover key={item.serialNumber} onClick={() => edit_nonDutyAssign(item)}>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.serialNumber}</StyledTableCell>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.consignmentNumber}</StyledTableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Grid>
                    <Grid item xs={10}>
                        <Item>
                            <FormControl margin="dense" size='small' InputLabelProps={{ shrink: true, }} style={{ width: '35%' }}>
                                <InputLabel id="Importer-label">Importer</InputLabel>
                                <Select native id="Importer" value={importer} label="Importer" onChange={importerHandelChange}>
                                    <option value=""> </option>
                                    {importerData.map((item) => (
                                        <option value={item.importer_iec_no}>{item.importer_name}</option>
                                    ))}
                                </Select>
                            </FormControl>
                            <TextField id="Job" style={{ marginLeft: '20px' }} value={jobvalue} label="Job.No" margin="dense" size='small' onChange={jobhandelChange} />
                            <Row >

                                {/* <Col xs={1}></Col> */}
                                <Col xs={5}>
                                    {/* <TextField required id="DutyAmtAsPerBOE" value={values.dutyamt_as_perBoe} label="DutyAmtAsPerBOE" margin="dense" variant="standard"
                                        onChange={dutyamt_as_perBoeHandelChange} /> */}

                                    <TextField required id="DutyPaidAmount" value={values.dutyPaidAmt}  label="Miscellaneous's Amount" margin="dense" variant="standard"
                                        onChange={dutyPaidAmtHandelChange} />

                                    <TextField required id="DutyPaidDate" style={{ marginLeft: '20px' }} value={values.dutyPaidDate} type='date' label="Miscellaneous's Paid Date" margin="dense" variant="standard" InputLabelProps={{
                                        shrink: true,
                                    }} sx={{ minWidth: 180 }}
                                        onChange={dutyPaidDatehandelChange} />

                                    <FormControl required margin="dense" variant="standard" size='small' InputLabelProps={{ shrink: true, }}
                                        style={{ width: '37%' }}>
                                        <InputLabel id="DutyPaidBy-label">Miscellaneous's paid By</InputLabel>
                                        <Select native id="DutyPaidBy" value={values.dutyPaidBy} label="DutyPaidBy" onChange={dutyPaidByHandelChange}>
                                            <option value=""> </option>
                                            <option value="IMPORTER">IMPORTER</option>
                                            <option value="NGPILLAI">NGPILLAI</option>
                                        </Select>
                                    </FormControl>
                                    <FormControl required margin="dense" variant="standard" size='small' InputLabelProps={{ shrink: true, }}
                                        style={{ width: '37%',marginLeft: '20px' }}>
                                        <InputLabel id="DutyPaidBy-label">Miscellaneous's paid TO</InputLabel>
                                        <Select native id="DutyPaidBy" value={values.dutyPaidTo} label="DutyPaidBy" onChange={dutyPaidToHandelChange}>
                                            <option value=""> </option>
                                            {billData.map((item)=>(
                                                <option value={item.billName}>{item.billName}</option>
                                            ))}
                                        </Select>
                                    </FormControl>

                                    <TextField id="Remarks" value={values.remarks} label="Remarks" margin="dense" variant="standard" onChange={remarksHandelChange} />

                                    <Row >
                                        <Col xs={4}>
                                            <label style={{ fontSize:'90%' }} onClick={uploadrqstcopy} className="btn btn-primary " >UPLOAD_COPY
                                                {imgUpload ? <input type="file" accept='.jpg,.jpeg,.png,.pdf' onChange={selectimgUpload} hidden /> : null}
                                            </label>
                                            {/* <Button variant="contained">UploadDutyCopy</Button> */}</Col>
                                        <Col xs={3}><Button variant="contained" onClick={saveDutyCopy} size='small'>Download_Copy</Button></Col>
                                    </Row>
                                    <br></br>
                                    <Row >
                                        <Col xs={3}><Button variant="contained" onClick={Save} size='small' disabled={saveDis}>{savePrc ? 'Processing..' : 'Svae'}</Button></Col>
                                        <Col xs={3}><Button variant="contained" onClick={Update} size='small' disabled={updateDis}>{updatePrc ? 'Processing..' : 'Update'}</Button></Col>
                                        <Col xs={3}><Button variant="contained" onClick={alertYDeleteClick} size='small' disabled={DeleteDis}>{deletePrc ? 'Processing..' : 'Delete'}</Button></Col>
                                    </Row><br></br>
                                    <Row>
                                        <Col xs={3}><Button variant="contained" size='small' onClick={reset}>Refresh</Button></Col>
                                    </Row>
                                </Col>

                                <Col xs={5}>
                                    <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '7px', fontFamily: 'Times New Roman' }}>Job Tracking Details</lable>
                                    <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                        <Table stickyHeader className='table table-bordered'>
                                            <TableHead>
                                                <StyledTableRow>
                                                    <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>OprLocation</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>OprDate</StyledTableCell>
                                                    <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>OprStatus</StyledTableCell>
                                                </StyledTableRow>
                                            </TableHead>
                                            <TableBody>
                                                {JobTrackingDetails.map((item, index) => (
                                                    <TableRow hover key={index}>
                                                        <StyledTableCell style={{ color: 'darkblue' }}>{item.userLocation}</StyledTableCell>
                                                        <StyledTableCell style={{ color: 'darkblue' }}>{item.operationDate}</StyledTableCell>
                                                        <StyledTableCell style={{ color: 'darkblue' }}>{item.operationStatus}</StyledTableCell>
                                                    </TableRow>
                                                ))}
                                            </TableBody>
                                        </Table>
                                    </TableContainer>
                                </Col>
                            </Row>
                            <br></br>
                            <TableContainer sx={{ maxHeight: 300 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Job.No</StyledTableCell>
                                            {/* <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>BOE Duty Amount </StyledTableCell> */}
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>TSP Paid Amount</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>TSP Paid Date</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>TSP Paid By</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>TSP Paid To</StyledTableCell>
                                            {/* <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Remarks</StyledTableCell> */}
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {DutyPaymentResult.map((item, index) => (
                                            <TableRow hover key={index} onClick={()=>edit_DutyAssign(item)}>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.consignmentId}</StyledTableCell>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.tspAmt}</StyledTableCell>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.tspPaidDate}</StyledTableCell>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.tspPaidBy}</StyledTableCell>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.tspPaidTo}</StyledTableCell>
                                                {/* <StyledTableCell style={{ color: 'darkblue' }}>{item.remarks}</StyledTableCell> */}
                                            </TableRow>))}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Grid>
                    {/* <Grid item xs={2}>
                        <Item>
                            <lable style={{ fontSize: '10px', fontWeight: 'bold', color: 'red', marginLeft: '7px', fontFamily: 'Times New Roman' }}> TSP Paid Job</lable>
                            <TableContainer sx={{ maxHeight: 500 }} className='scrollbarPrime'>
                                <Table stickyHeader className='table table-bordered'>
                                    <TableHead>
                                        <StyledTableRow>
                                            <StyledTableCell style={{ width: '10px', textAlign: 'center' }}>Sl</StyledTableCell>
                                            <StyledTableCell style={{ width: '40px', textAlign: 'center' }}>Job.No</StyledTableCell>
                                        </StyledTableRow>
                                    </TableHead>
                                    <TableBody>
                                        {DutyData.map((item) => (
                                            <TableRow hover key={item.serialNumber} onClick={() => edit_DutyAssign(item)}>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.serialNumber}</StyledTableCell>
                                                <StyledTableCell style={{ color: 'darkblue' }}>{item.consignmentNumber}</StyledTableCell>
                                            </TableRow>))}

                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Item>
                    </Grid>*/}
                </Grid> 
            </div>
        </div>
    )
}

export default MiscellaneousPayment